import React from 'react';
import { ifProp } from 'src/shared/styled-utils/ifProp';
import styled, { css } from 'styled-components';
import { Colors, Font } from 'web-common/src/shared/styles';

const RadioButton = styled.div<{ selected: boolean }>`
  width: 160px;
  height: 42px;
  border-radius: 21px;
  text-align: center;
  line-height: 42px;
  cursor: pointer;
  ${ifProp(
    'selected',
    css`
      background-color: white;
      font-weight: 600;
    `
  )}
`;

const RadioButtonRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: none;
  padding: 4px;
  border-radius: 25px;
  background-color: ${Colors.GRAY_LITE_20};

  font-family: ${Font.Family.SANS};
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: black;
`;

export interface IRadioButtonGroupProps {
  options: string[];
  selected: string;
  onChange: (option: string) => any;
  className?: string;
}
export const RadioButtonGroup = React.forwardRef<HTMLDivElement, IRadioButtonGroupProps>(
  ({ options, selected, onChange, className }, ref) => (
    <RadioButtonRow className={className} ref={ref}>
      {options.map((option) => (
        <RadioButton key={option} selected={selected === option} onClick={() => onChange(option)}>
          {option}
        </RadioButton>
      ))}
    </RadioButtonRow>
  )
);
